import {FormCheckboxField} from '@components/form/FormCheckboxField';
import {FormInputField} from '@components/form/FormInputField';
import {FormRadioField} from '@components/form/FormRadioField';
import {FormSelectField} from '@components/form/FormSelectField';
import {FormHiddenField} from '@components/form/HiddenInputField';
import {Component} from '@lib/Component';

import {BaseFormField, IField} from './BaseFormField';

type FieldType =
  | 'input'
  | 'radio'
  | 'checkbox'
  | 'select'
  | 'date'
  | 'hidden'
  | 'textarea';

export class Form extends Component<HTMLFormElement> {
  fields: BaseFormField<any>[] = [];

  get isValid() {
    return this.fields?.every((field) => {
      return field.validate();
    });
  }

  didMount() {
    const fields = [
      ...(this.element?.querySelectorAll?.(
        '.js-form-field',
      ) as NodeListOf<HTMLDivElement>),
    ];

    fields.map((element) => {
      const field = this._getField(element);
      field?.mount(element);
      if (field) {
        this.fields.push(field);
      }
    });
  }

  didUnmount() {
    this.fields.map((field) => field.destroy());
  }

  getByName(name: string): IField {
    const [result] =
      this.fields.filter((f) => {
        return f.name === name;
      }) || [];
    return result;
  }

  private _getField(element: HTMLDivElement): BaseFormField<any> | null {
    const type = (element.dataset['type'] as FieldType) || 'input';
    switch (type) {
      case 'input':
      case 'textarea':
        return new FormInputField();
      case 'radio':
        return new FormRadioField();
      case 'checkbox':
        return new FormCheckboxField();
      case 'select':
        return new FormSelectField();
      case 'hidden':
        return new FormHiddenField();
      default:
        return null;
    }
  }
}
